import { useAppAuth } from '@/lib/useAppAuth';
import { TopBar } from './TopBar';
import { GuestTopBar } from './GuestTopBar';

export interface TopBarContainerProps {
  /**
   * When `true`, renders {@link TopBar} in compact mode (hidden avatar,
   * smaller balance pill and typography). Used by the home top bar when
   * the sticky header is pinned to the viewport.
   */
  compact?: boolean;
}

/**
 * Data-fetching wrapper for {@link TopBar}.
 *
 * Renders {@link GuestTopBar} only for true visitors (no session). A registered
 * account mid-onboarding — e.g. sitting on the email-verification step — already
 * gets the authenticated {@link TopBar}: the Log In / Sign Up buttons would be
 * wrong the moment signup created the account.
 */
export function TopBarContainer({ compact = false }: TopBarContainerProps = {}) {
  const { isAuthenticated } = useAppAuth();
  if (!isAuthenticated) return <GuestTopBar />;
  return <TopBar compact={compact} />;
}
